<template>
  <v-app-bar variant="compact" :app="true" color="var(--color-app-bar)">
    <template v-for="(item, index) in getNavItems()">
      <v-toolbar-items v-if="item.v4lOnly" :key="index">
        <v-divider v-if="item.bar" :inset="true" :vertical="true" />
        <v-btn
          v-if="item.badges && item.badgeValue > 0"
          variant="text"
          :aria-label="item.a11y"
          @click="navigate(item, index)"
        >
          <v-badge :content="item.badgeValue" bottom right> </v-badge>
          <div :class="getNavClass(item.index)" v-text="item.name" />
        </v-btn>
        <v-btn
          v-else
          variant="text"
          :aria-label="item.a11y"
          @click="navigate(item, index)"
        >
          <div :class="getNavClass(item.index)" v-text="item.name" />
        </v-btn>
      </v-toolbar-items>
    </template>
    <v-spacer />
    <HelpInformation
      color="var(--color-brand)"
      iconcolor="var(--color-white)"
      style="padding-right: 0.3vw; padding-left: 0.3vw"
    />
    <v-btn variant="text" color="var(--color-white)">
      <span style="color: var(--color-white)">{{
        getAvatarDisplayName(true)
      }}</span>
    </v-btn>
    <v-btn :class="getNavClass(10)" size="small" @click="doSettings()">
      <v-icon color="var(--color-white)">mdi-dots-vertical</v-icon>
    </v-btn>
    <!--
    <v-btn
      icon="mdi-logout-variant"
      :class="getNavClass(20)"
      size="small"
      @click="userLogout()"
    />
    -->
  </v-app-bar>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const OIDC_ENDSESSION_URL = import.meta.env.VITE_OIDC_ENDSESSION_URL
const POST_LOGOUT_REDIRECT_URI_USER = import.meta.env
  .VITE_POST_LOGOUT_REDIRECT_URI_USER

export default {
  name: 'NavigationSystem',
  components: {
    //  NavIcon: () => import('@/components/menues/NavIcon'),
    HelpInformation: defineAsyncComponent(
      () => import('@/components/menues/HelpInformation.vue')
    )
  },
  props: {
    location: { type: String, default: 'top' }
  },
  data() {
    return {
      activeMenyItem: -1,
      countUnassessed: 0
    }
  },
  computed: {},
  mounted() {
    this.setActiveNavItem(-1)
  },
  methods: {
    ...mapActions(adminStore, ['logout', 'setActiveNavItem']),
    ...mapState(adminStore, [
      'getDisplayName',
      'getActiveNavItem',
      'getOnlyV4L',
      'getActiveLearnerInfo',
      'getIdToken',
      'isExperimental',
      'getEU'
    ]),
    getName() {
      return this.getDisplayName()
    },
    getActiveNav() {
      // console.log('getActiveNav(%s)', this.getActiveNavItem())
      return this.getActiveNavItem().index
    },
    getAvatarDisplayName(avatar) {
      if (avatar) {
        let name = this.getDisplayName() || 'No Name'
        let nameParts = name.split(' ')
        //console.log('NAMEPARTS (%s) (%s)', nameParts[0], nameParts[1])
        if (nameParts.length > 1) {
          return (
            nameParts[0].substring(0, 1).toUpperCase() +
            nameParts[1].substring(0, 1).toUpperCase()
          )
        } else if (nameParts.length > 0) {
          return nameParts[0].substring(0, 1).toUpperCase()
        } else {
          return ''
        }
      } else {
        return this.getDisplayName()
      }
    },
    getNavClass(navIndex) {
      //console.log('GET NAV CLASS (%s) (%s)', this.getActiveNav(), navIndex)
      if (this.getActiveNav() === navIndex) {
        return 'labelactive'
      } else {
        return 'label'
      }
    },
    navigate(item) {
      console.log('NAVIGATE got called !', item)
      // item.index = itemIndex;
      this.setActiveNavItem(item)
      this.$router
        .push({
          name: item.pathName
        })
        .catch((err) => {
          console.error(
            'Could not navigate to: (%s) - (%j)',
            item.pathName,
            err
          )
        })
    },
    doSettings() {
      //console.log('++++++++++ NEW PATH (/settings/)')
      this.setActiveNavItem(10)
      this.activeMenyItem = 10
      this.$router
        .push({
          name: 'EducatorSettings'
        })
        .catch(() => {})
    },
    getNavItems() {
      return [
        {
          /* 5 V4L */ // Læringsmål
          index: 5,
          name: this.$t('nav.nav5'),
          a11y: this.$t('nav.nav5'),
          pathName: 'CurriculumView',
          v4lOnly: true
        },
        /*
        {
          / * 0 * / // Hjem
          index: 0,
          name: this.$t('nav.nav0'),
          a11y: this.$t('nav.nav0'),
          pathName: 'Contribution',
          v4lOnly: !this.getOnlyV4L()
        },
        */
        /* 1
        {

          index: 1,
          name: this.$t('nav.nav1'),
          a11y: this.$t('nav.nav1'),
          pathName: 'SelfAssessment',
          v4lOnly: !this.getOnlyV4L()
        },
        {
          / * 2 * /
          index: 2,
          name: this.$t('nav.nav2'),
          a11y: this.$t('nav.nav2'),
          pathName: 'Homework',
          v4lOnly: this.getOnlyV4L()
        },
        */

        {
          /* 7 V4L */ // Oppgaver
          index: 7,
          name: this.$t('nav.nav7'),
          a11y: this.$t('nav.nav7'),
          pathName: 'CreateAssignment',
          v4lOnly: true
        },
        /* 8 V4L
        {
          index: 8,
          name: this.$t('nav.nav8'),
          a11y: this.$t('nav.nav8'),
          pathName: 'EducatorAssessAssignments',
          badges: true,
          badgeValue: this.countUnassessed,
          v4lOnly: !this.getOnlyV4L() // true
        }, */ // Vurderinger
        {
          /* 6 V4L */ // PÅGÅENDENDE OPPGAVER
          index: 6,
          name: this.$t('nav.nav9'),
          a11y: this.$t('nav.nav9'),
          pathName: 'TodaysActiveAssignments',
          v4lOnly: true
        },
        {
          /* 6 V4L */ // Rediger felles oppgaver
          index: 13,
          name: this.$t('nav.nav13'),
          a11y: this.$t('nav.nav13'),
          pathName: 'EditAssignments',
          v4lOnly: !this.getEU()
        },
        /* 3
        {

          index: 3,
          name: this.$t('nav.nav3'),
          a11y: this.$t('nav.nav3'),
          pathName: 'UserSettings',
          v4lOnly: !this.getOnlyV4L()
        },
        */
        {
          /* 6 */ // ELEVER
          index: 9,
          name: this.$t('nav.nav6'),
          a11y: this.$t('nav.nav6'),
          pathName: 'LearnerList',
          v4lOnly: true,
          bar: true
        }
      ]
    },
    getNumberPeerReviewAssignments() {
      let learnerInfo = this.getActiveLearnerInfo() || {}
      let peerReviewAssignments = learnerInfo.assignmentsForPeerReview || []
      console.log(
        'getNumberPeerReviewAssignments got called (%s) ',
        peerReviewAssignments.length
      )
      console.log(peerReviewAssignments)
      return peerReviewAssignments.length
    },
    getNumberActiveWrittenAssignment() {
      //  console.log('getNumberActiveWrittenAssignments!')
      let now = this.$date()
      let learner = this.getActiveLearnerInfo()
      let subjects = learner.learnerHasSubject || []
      let activeWrittenAssignments = []
      // console.log('subjects.length(%s)', subjects.length)
      for (let i = 0; i < subjects.length; i++) {
        let subject = subjects[i]
        //  console.log(subject)
        let commonSubjectGroup = subject.learnerHasCommonSubjectGroup || {}
        let writtenAssignments = commonSubjectGroup.hasWrittenAssignment || []
        // console.log('Written Assignments length(%s)', writtenAssignments.length)
        for (let j = 0; j < writtenAssignments.length; j++) {
          let writtenAssignment = writtenAssignments[j]
          if (
            now.isBetween(
              this.$date(writtenAssignment.writtenassignment_start_date),
              this.$date(writtenAssignment.writtenassignment_end_date)
            )
          ) {
            activeWrittenAssignments.push(writtenAssignment)
          }
        }
      }
      return activeWrittenAssignments.length || 0
    },
    userLogout() {
      let token = this.getIdToken()
      console.log('logout got called !')
      sessionStorage.removeItem('lid')
      sessionStorage.removeItem('sid')
      sessionStorage.removeItem('ssa')
      this.setActiveNavItem(20)
      this.activeMenyItem = 20
      this.logout()

      //          window.open('https://auth.dataporten.no/logout', '_self', true)
      window.open(
        `${OIDC_ENDSESSION_URL}?post_logout_redirect_uri=${POST_LOGOUT_REDIRECT_URI_USER}&id_token_hint=${token}`,
        '_self',
        true
      )
    },
    logout2() {
      console.log('logout got called !')
      sessionStorage.removeItem('lid')
      sessionStorage.removeItem('sid')
      sessionStorage.removeItem('ssa')
      this.logout()
        .then(() => {})
        .catch((error) => {
          console.error('PROBLEMS LOGGING OUT (%o)', error)
        })
        .finally(() => {
          this.$router
            .push({
              name: 'StartPage'
            })
            .catch(() => {})
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-wrapper {
  border-top: 1px solid var(--color-main-header);
  padding: 0.5rem 0 0.5rem 0;
}
.nav {
  // display: flex;
  align-items: center;
}
.nav-item {
  // flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  &.active {
    color: var(--color-brand-100);
  }
}
.icon {
  margin-bottom: 0.5rem;
}
.label {
  display: flex;
  font-family: var(--text-font-heading);
  font-variation-settings: 'wght' 575;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.02rem;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  color: var(--color-white);
}

.labelactive {
  display: flex;
  font-family: var(--text-font-heading);
  font-size: 1.1rem;
  text-align: center;
  letter-spacing: 0.05rem;
  font-weight: 800;
  color: var(--color-white);
  white-space: nowrap;
}

.active {
  display: flex;
}
</style>
